import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/toyotaTheme";
import * as Styles from "../../../../shared-components/deprecated-styled-components/toyota/custom/PageDisclaimer";

export const Wrapper = styled(Styles.Wrapper)`
    margin: 0;
    padding-top: var(--spacing-4);
    padding-bottom: var(--spacing-6);
    background-color: var(--color-primary-white);
`;

export const Content = styled.div`
    --disclaimer-content-padding: var(--spacing-3);
    padding-left: var(--disclaimer-content-padding);
    padding-right: var(--disclaimer-content-padding);

    @media screen and (min-width: ${breakpoints.xxl}) {
        --disclaimer-content-padding: var(--spacing-7);
    }

    @media screen and (min-width: ${breakpoints.max}) {
        --disclaimer-content-padding: 0;
    }
`;

export const Title = styled(Styles.Title)``;
